<template>
  <div class="container-video-inline-scroll">
    <div class="container-video-inline-scroll__video-full" :class="position">
      <VideoMcpViewer :regular-player="regular" :mcp-id="mcp" :video-uniq-id="videoUniq" :play-video="true" class="container-video-multimedia d-md-block d-none" :bg-loop="true" />
      
      <VideoMcpViewer :regular-player="regular" :mcp-id="mcpMobile" :video-uniq-id="videoUniq" :play-video="true" class="container-video-multimedia d-block d-md-none" :bg-loop="true" />
    </div>
    <div class="legend" v-if="legend" :class="align">
      <div v-html="legend"></div>
    </div>
  </div>
</template>

<style lang="scss">
  .container-video-inline-scroll {
    position: relative;
    width: calc(100vw);
    height: 200vh;
    left: calc((100vw - 98%) / 2 * -1);
    margin: 55px 0;

    &__video-full {
      position: sticky;
      top: 0;
      display: block;
      width: 100%;
      height: 100vh;
      object-fit: cover;
      object-position: center top;

      &.center video {
        object-position: 55% top !important;
      }

      &.right {
        object-position: 70% top !important;
      }
      
      &.left {
        object-position: 20% top !important;
      }

      &.l-center video {
        object-position: 45% top !important;
      }
    }

    .legend {
      position: relative;
      margin: 0 auto;
      padding: 10px;
      font-size: 20px;
      font-weight: 300;
      font-family: 'Roboto Slab';
      color: #333;
      background: #ffffffe8;
      width: 100%;
      max-width: 560px;
      text-align: center;
      box-shadow: 0px 0px 2px 2px #33333314;


      &.left {
        margin: 0 auto 0 5% !important;
        max-width: 440px;
      }

      @media (max-width: 575.98px) {
        &.left {
          margin: 0 auto 0 auto !important;
          max-width: 480px;
        }
      }
    }
  }
</style>

<script>

  import VideoMcpViewer from '@/components/VideoMcpViewer'
  
  export default {
    name: 'VideoScrollMobile',
    props: {
      src: {
        type: String,
        default: ``
      }
    },
    components: {
      VideoMcpViewer
    },
    computed: {
      videoUniq() {
        return `video_scroll_${this._uid}`
      },
      mcp() {
        const path = this.src.split(';')
        if(path[0])
          return path[0]
        return this.src
      },
      mcpMobile() {
        const path = this.src.split(';')
        if(path[0])
          return (path[0]).replace(".mp4","_movil.mp4")
        return this.src
      },
      legend() {
        const path = this.src.split(';')
        if(path[1])
          return path[1]
        return ``
      },
      regular() {
        const path = this.src.split(';')
        if(path[2])
          return true
        return false
      },
      align() {
        const path = this.src.split(';')
        if(path[3])
          return path[3]
        return false
      },
      position() {
        const path = this.src.split(';')
        if(path[4])
          return path[4]
        return false
      }
    }
  }
</script>